import { Component, HostBinding, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

/**
 * Commponent for stepper fields
 */
@Component({
  selector: '[app-form-field-stepper]',
  templateUrl: './form-field-stepper.component.html',
})
export class FormFieldStepperComponent implements OnInit, OnDestroy, OnChanges {
  @HostBinding('class.esf-form-item') public get formItemClass(): boolean {
    return true;
  }

  @Input() public optional: boolean = false;
  @Input() public placeholder: string = '';
  @Input() public label: string = '';
  @Input() public control: AbstractControl;
  @Input() public min: number = 1;
  @Input() public max: number = 100;
  @Input() public smallButtons: boolean = false;
  public id: string;
  constructor() { }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  get controlValue(): number {
    return this.control.value;
  }

  public ngOnInit(): void {
    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  ngOnChanges(): any {
    if (this.min > this.controlValue) {
      this.control.setValue(this.min);
    }
  }

  public increment(): void {
    this.control.patchValue(this.controlValue + 1);
  }

  public decrement(): void {
    this.control.patchValue(this.controlValue - 1);
  }

  public ngOnDestroy(): void { }

}
